import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { useForm } from 'react-hook-form'

import useMediaQuery from '@equifax-ui/hooks/useMediaQuery'

import {
  RECOMMENDED_PLAN_PRICE,
  RECOMMENDED_PLAN_SLUG
} from '@/constants/plans'

import { getAllParams } from '@/utils/browser'

export const usePlansSection = ({ customSubmit }) => {
  const [selectedPlan, setSelectedPlan] = useState(RECOMMENDED_PLAN_SLUG)
  const [isLoading, setIsLoading] = useState(false)
  const [isSimulationVisible, setIsSimulationVisible] = useState(false)

  const router = useRouter()

  const isMobile = useMediaQuery('screen and (max-width: 1024px)')

  const { control, setValue, handleSubmit } = useForm({
    mode: 'onChange',
    defaultValues: {
      plan_price: RECOMMENDED_PLAN_PRICE
    }
  })

  const onSelectPlan = ({ plan_price, slug_name }) => {
    setSelectedPlan(slug_name)
    setValue('plan_price', plan_price)
  }

  const onSubmit = ({ plan_price }) => {
    if (customSubmit) {
      customSubmit({ plan_price })
      return
    }

    setIsLoading(true)

    const params = getAllParams('plano', selectedPlan)

    router.push(`/formulario/dados-basicos/${params}`)
  }

  return {
    control,
    isLoading,
    isMobile,
    isSimulationVisible,
    setIsSimulationVisible,
    onSelectPlan,
    onSubmit,
    handleSubmit
  }
}
